<template>
    <div class="flex w-full flex-col md:flex-row">
        <!-- 搜索部 -->
        <div class="hidden md:block bg-white border-2 border-gray-400 rounded-md p-4">
            <el-form :model="modelValue" label-width="auto" label-position="top">
                <div class="grid gap-4"
                    :class="[
                        loginUserRole === ROLES.SYSTEM ? 'md:grid-cols-5' : (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead ? 'md:grid-cols-4' : 'md:grid-cols-3'),
                    ]">
                    <el-form-item class="no-margin"
                        v-show="loginUserRole === ROLES.SYSTEM" label="組織">
                        <OrganizationSelect :model-value="modelValue.organization_id" :is-search="true" placeholder="組織を選択"
                            @update:model-value="$emit('update:modelValue', { ...modelValue, organization_id: $event })" />
                    </el-form-item>

                    <el-form-item class="no-margin" v-show="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)" label="部門">
                        <DepartmentSelect :organization-id="modelValue.organization_id" :is-search="true" 
                            :model-value="modelValue.department_id" placeholder="部門を選択"
                            @update:model-value="$emit('update:modelValue', { ...modelValue, department_id: $event })"
                            @organization-id-change="$emit('organizationIdChange', $event)" />
                    </el-form-item>

                    <el-form-item class="no-margin" label="カテゴリ">
                        <CategorySelect :organization-id="modelValue.organization_id"
                            :model-value="modelValue.category_id" :is-search="true" placeholder="カテゴリを選択"
                            @update:model-value="$emit('update:modelValue', { ...modelValue, category_id: $event })" />
                    </el-form-item>

                    <el-form-item class="no-margin" label="アイテム名">
                        <AutoCompleteInput 
                            :model-value="modelValue.material_name" 
                            placeholder="アイテム名を入力"
                            storage-key="material-name-history"
                            :max-history-items="15"
                            ref="materialNameInput"
                            @update:model-value="$emit('update:modelValue', { ...modelValue, material_name: $event })"
                        />
                    </el-form-item>

                    <div class="flex justify-end mt-7">
                        <el-button class="w-24" type="info" @click="handleSearch">検索</el-button>
                    </div>
                </div>
            </el-form>
        </div>

        <el-drawer class="md:hidden bg-gray-200" v-model="drawer" title="検索" direction="ttb" :with-header="false" size="auto">
            <div class="bg-white border-2 border-gray-400 rounded-md p-4">
                <el-form :model="modelValue" label-width="auto" label-position="top">
                    <div class="grid gap-4">
                        <el-form-item class="no-margin"
                        v-show="loginUserRole === ROLES.SYSTEM" label="組織">
                        <OrganizationSelect :model-value="modelValue.organization_id" :is-search="true" placeholder="組織を選択"
                            @update:model-value="$emit('update:modelValue', { ...modelValue, organization_id: $event })" />
                    </el-form-item>

                    <el-form-item class="no-margin" v-show="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)" label="部門">
                        <DepartmentSelect :organization-id="modelValue.organization_id" :is-search="true" 
                            :model-value="modelValue.department_id" placeholder="部門を選択"
                            @update:model-value="$emit('update:modelValue', { ...modelValue, department_id: $event })"
                            @organization-id-change="$emit('organizationIdChange', $event)" />
                    </el-form-item>

                    <el-form-item class="no-margin" label="カテゴリ">
                        <CategorySelect :organization-id="modelValue.organization_id"
                            :model-value="modelValue.category_id" :is-search="true" placeholder="カテゴリを選択"
                            @update:model-value="$emit('update:modelValue', { ...modelValue, category_id: $event })" />
                    </el-form-item>

                        <div class="flex">
                            <el-form-item class="no-margin flex-grow" label="アイテム名">
                                <AutoCompleteInput 
                                    :model-value="modelValue.material_name" 
                                    placeholder="アイテム名を入力"
                                    storage-key="material-name-history"
                                    :max-history-items="15"
                                    ref="materialNameInput"
                                    @update:model-value="$emit('update:modelValue', { ...modelValue, material_name: $event })"
                                />
                            </el-form-item>

                            <div class="flex justify-end mt-7">
                                <el-button class="md:hidden ml-3" type="info" @click="handleSearch" circle>
                                    <el-icon>
                                        <span class="material-symbols-outlined">manage_search</span>
                                    </el-icon>
                                </el-button>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
        </el-drawer>

        <!-- 操作部 -->
        <div class="flex justify-end items-center md:flex-grow">
            <div class="flex flex-grow items-center xl:justify-end">
                <!-- アラート区分 -->
                <div class="md:hidden xl:block">
                    <div class="flex justify-end">
                        <span class="text-xs md:text-sm m-2 font-bold">アラート区分</span>
                        <div class="flex flex-wrap gap-x-2">
                            <div class="flex items-center">
                                <div class="h-3 w-3 bg-[#E63415] rounded-sm"></div>
                                <span class="ml-1 text-xs md:text-sm">1日以内</span>
                            </div>
                            <div class="flex items-center">
                                <div class="h-3 w-3 bg-[#FF6600] rounded-sm"></div>
                                <span class="ml-1 text-xs md:text-sm">1日前</span>
                            </div>
                            <div class="flex items-center">
                                <div class="h-3 w-3 bg-[#FFDE0A] rounded-sm"></div>
                                <span class="ml-1 text-xs md:text-sm">7日前</span>
                            </div>
                            <div class="flex items-center">
                                <div class="h-3 w-3 bg-[#1EC79D] rounded-sm"></div>
                                <span class="ml-1 text-xs md:text-sm">15日前</span>
                            </div>
                            <div class="flex items-center">
                                <div class="h-3 w-3 bg-[#14CCCC] rounded-sm"></div>
                                <span class="ml-1 text-xs md:text-sm">30日前</span>
                            </div>
                            <div class="flex items-center">
                                <div class="h-3 w-3 bg-[#4167F0] rounded-sm"></div>
                                <span class="ml-1 text-xs md:text-sm">在庫数</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 操作按钮 -->
            <div class="flex flex-col">
                <div class="flex justify-end">
                    <el-button class="custom-icon-btn md:hidden" type="info" 
                        @click="drawer = true" circle>
                        <span class="material-symbols-outlined">
                            manage_search
                        </span>
                    </el-button>

                    <el-button class="custom-icon-btn md:hidden" type="info"
                        @click="$emit('add')" circle>
                        <span class="material-symbols-outlined">
                            add
                        </span>
                    </el-button>
                    <el-button class="hidden md:block w-24" type="info"
                        @click="$emit('add')">新規登録</el-button>

                    <el-upload class="" ref="upload" :on-change="handleImport" :auto-upload="false"
                        :show-file-list="false" accept=".csv">
                        <el-tooltip content="CSVインポート" placement="top">
                            <el-button class="custom-icon-btn mx-3" type="info" circle>
                                <span class="material-symbols-outlined">
                                    upload_2
                            </span>
                        </el-button>
                        </el-tooltip>
                    </el-upload>

                    <el-button class="custom-icon-btn" type="info" 
                        @click="$emit('export')" circle>
                        <el-tooltip content="CSVエクスポート" placement="top">
                            <span class="material-symbols-outlined">
                                download_2
                            </span>
                        </el-tooltip>
                    </el-button>
                </div>

                <div class="flex justify-end hidden md:block xl:hidden">
                    <span class="text-sm mr-2 font-bold">アラート区分</span>
                    <div class="flex flex-wrap gap-x-2">
                        <div class="flex items-center">
                            <div class="h-3 w-3 bg-[#E63415] rounded-sm"></div>
                            <span class="ml-1 text-sm">1日以内</span>
                        </div>
                        <div class="flex items-center">
                            <div class="h-3 w-3 bg-[#FF6600] rounded-sm"></div>
                            <span class="ml-1 text-sm">1日前</span>
                        </div>
                        <div class="flex items-center">
                            <div class="h-3 w-3 bg-[#FFDE0A] rounded-sm"></div>
                            <span class="ml-1 text-sm">7日前</span>
                        </div>
                        <div class="flex items-center">
                            <div class="h-3 w-3 bg-[#1EC79D] rounded-sm"></div>
                            <span class="ml-1 text-sm">15日前</span>
                        </div>
                        <div class="flex items-center">
                            <div class="h-3 w-3 bg-[#14CCCC] rounded-sm"></div>
                            <span class="ml-1 text-sm">30日前</span>
                        </div>
                        <div class="flex items-center">
                            <div class="h-3 w-3 bg-[#4167F0] rounded-sm"></div>
                            <span class="ml-1 text-sm">在庫数</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import OrganizationSelect from '@/components/common/OrganizationSelect.vue';
import DepartmentSelect from '@/components/common/DepartmentSelect.vue';
import CategorySelect from '@/components/common/CategorySelect.vue';
import AutoCompleteInput from '@/components/common/AutoCompleteInput.vue';
import { ROLES } from '@/config/constants';

export default defineComponent({
    name: 'InventorySearchForm',
    components: {
        OrganizationSelect,
        DepartmentSelect,
        CategorySelect,
        AutoCompleteInput,
    },
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
        loginUserRole: {
            type: String,
            required: true,
        },
        loginUserRoleIsHead: {
            type: Boolean,
            required: true,
        },
        // isGrid: {
        //     type: Boolean,
        //     default: false,
        // },
    },
    emits: ['update:modelValue', 'search', 'add', 'export', 'import', 'organizationIdChange'], // 移除 'toggleGrid'
    setup(props, { emit }) {
        const materialNameInput = ref<any>(null);

        const drawer = ref(false);

        const handleSearch = () => {
            drawer.value = false;

            if (materialNameInput.value) {
                materialNameInput.value.submitValue();
            }
            emit('search');
        };

        const handleImport = (file: any) => {
            emit('import', file);
        };

        return {
            materialNameInput,
            handleSearch,
            handleImport,
            ROLES,
            drawer,
        };
    },
});
</script>